(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hebeso-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const bind = (scope = document) => {
    scope.querySelectorAll('[data-hebeso-nav]').forEach(root => {
      if (root.dataset.hbnReady) return;
      root.dataset.hbnReady = 'true';
      const desktop = root.dataset.hebesoNav === 'desktop';
      const disclosures = [...root.querySelectorAll('[data-hbn-disclosure]')];
      let closeTimer;
      const cancelClose = () => window.clearTimeout(closeTimer);
      const closeAll = () => {
        cancelClose();
        disclosures.forEach(details => { details.open = false; });
      };
      const openOnly = active => {
        cancelClose();
        disclosures.forEach(details => { details.open = details === active; });
      };
      if (desktop) {
        const canHover = () => window.matchMedia('(min-width:860px) and (hover:hover) and (pointer:fine)').matches;
        disclosures.forEach(details => {
          details.addEventListener('pointerenter', event => {
            if (event.pointerType !== 'touch' && canHover()) openOnly(details);
          });
          details.addEventListener('pointerleave', event => {
            if (event.pointerType === 'touch' || !canHover()) return;
            cancelClose();
            closeTimer = window.setTimeout(() => {
              if (!details.querySelector('.hbn-panel').contains(document.activeElement)) details.open = false;
            }, 180);
          });
          details.querySelector('summary').addEventListener('click', event => {
            if (canHover() && event.detail > 0 && event.pointerType !== 'touch') {
              event.preventDefault();
              openOnly(details);
            }
          });
          details.addEventListener('toggle', () => {
            if (details.open) disclosures.forEach(other => { if (other !== details) other.open = false; });
          });
        });
        document.addEventListener('click', event => { if (!root.contains(event.target)) closeAll(); });
        root.addEventListener('focusin', cancelClose);
        root.addEventListener('focusout', event => { if (event.relatedTarget && !root.contains(event.relatedTarget)) closeAll(); });
        window.addEventListener('resize', () => { if (window.matchMedia('(max-width:859px)').matches) closeAll(); });
      }
      root.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const active = disclosures.find(details => details.open);
        if (active) {
          event.preventDefault();
          event.stopPropagation();
          closeAll();
          active.querySelector('summary').focus();
        }
      });
      if (!desktop) root.addEventListener('click', event => {
        if (event.target.closest('a[href]')) root.closest('[data-mobile-nav]')?.querySelector('[data-mobile-nav-close]')?.click();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind(), {once:true});
  else bind();
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
